import {map as rxjsMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {settings} from '../../app.settings';
import {Strategy} from '../../shared/models/strategy';
import {BaseService} from '~common/app/shared/services/base.service';
import { HttpParams } from '@angular/common/http';

const API_PATH = settings.api.url + '/strategies';

@Injectable()
export class StrategyService extends BaseService {

  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  get(id): Observable<any> {
    return this.http.get(API_PATH + '/' + id).pipe(rxjsMap(response => {
      return this.hydrate(Strategy, response);
    }));
  }

  fetchPhases(id: string, params = {}) {
    let apiParams = new HttpParams();

    apiParams = apiParams.append('per_page', '100');

    return this.http.get(API_PATH + '/' + id + '/phases', {
      params
    });
  }
}
